/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * @param {{ date: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const explain_sealed_body = (params) => `Dein Ticket wird erst kurz vor der Veranstaltung sichtbar — ab ${params.date}. Das ist Absicht: Ein Ticket, das es noch nicht gibt, kann auch nicht kopiert oder an uns vorbei weiterverkauft werden.`
